import API from '../..';
const ENTITY = 'projects';

export const bulkProjects = (data) =>
    API.put(`/api/v1/${ENTITY}/bulk-status/`, data, {
        headers: { 'Content-Type': 'application/json' },
    });
export const createProject = (data) => API.post(`/api/v1/${ENTITY}/`, data);
export const filterProjects = ({
    contactId = null,
    orderBy = 'created_at',
    page = 1,
    perPage = 25,
    projectStatus,
    searchText = '',
    sortBy = null,
    status = 'active',
} = {}) =>
    API.get(`/api/v1/${ENTITY}/`, {
        params: {
            ...(contactId ? { contact: contactId } : {}),
            order_by: orderBy,
            page: page,
            per_page: perPage,
            search: searchText,
            sort: sortBy,
            ...(projectStatus ? { status: projectStatus } : {}),
            status_flag: status,
        },
    });
export const getProject = (projectId) =>
    API.get(`/api/v1/${ENTITY}/${projectId}/`);
export const updateProject = (data, id) =>
    API.put(`/api/v1/${ENTITY}/${id}/`, data);
